import { apiSlice } from '../../api/slice'

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getContractByName: builder.query<any, any>({
      query: ({ name, chainId = '8453' }) => ({
        url: `/contracts/${chainId}/${name}`,
      }),
    }),
    getEthUsdPrice: builder.query({
      query: () => ({
        url: `/contracts/eth-usd`,
      }),
    }),
    getVaultForUser: builder.query({
      query: () => ({
        url: `/vault/user`,
      }),
    }),
    getNftDropsForUser: builder.query({
      query: () => ({
        url: `/nft-drop/all-for-user`,
      }),
    }),
    getNftDropsForGuest: builder.query({
      query: () => ({
        url: `/nft-drop/all-for-guest`,
      }),
    }),
  }),
})

export const {
  useGetContractByNameQuery,
  useLazyGetContractByNameQuery,
  useGetEthUsdPriceQuery,
  useLazyGetEthUsdPriceQuery,
  useGetVaultForUserQuery,
  useLazyGetVaultForUserQuery,
  useGetNftDropsForUserQuery,
  useGetNftDropsForGuestQuery,
} = userApiSlice
